import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';
import { GenericService } from 'src/app/services/generic.service';
import { ToastrService } from 'ngx-toastr';
import { videoURL } from 'src/app/services/base-url';

@Component({
  selector: 'app-title-workflow',
  templateUrl: './title-workflow.component.html',
  styleUrls: ['./title-workflow.component.css']
})
export class TitleWorkflowComponent implements OnInit {

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  episodeList: any = [];
  pageNumber: number = 1;
  totalRecords: number = 0;
  first: number = 0;
  tableSize: number = 10;
  isLoading: boolean = false;
  searchFilter: string = "";

  selectedEpisode: any = null;
  titleForm: any | FormGroup;
  formSubmit: boolean = false;
  cid: any;
  loggedInUserId: any;

  userList: any[] = [];
  qualityCheckUserList: any[] = [];
  directorUserList: any[] = [];
  selectedUserIdToAssign: any = "";
  videoUrl: any = videoURL
  userType: any = "";

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private genericService: GenericService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.initForm();
    this.userType = sessionStorage.getItem("userType");
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
    this.getAllUsers();
  }

  getAllEpisodes() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllEpisodes().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response.filter((e: any) => e.currentStage === 'TITLE');
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        if (res && res.response) {
          this.userList = res.response;
          this.qualityCheckUserList = this.userList.filter((u: any) => u.userType === 'QUALITY');
          this.directorUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');

        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  initForm() {
    this.titleForm = this.fb.group({
      titleCreationUser: [''],
      assignToTitleTeamOnDate: [''],
      titleCreationStartDate: [''],
      titleCreationEndDate: [''],
      suggestedTitles: [''],
      approvedTitle: [''],
      commonNotes: ['']
    });
  }

  getAllTvProductionTrackersUserId() {
    this.isLoading = true;
    this.tvProductionTrackerService.getAllTvProductionTrackersUserId(this.loggedInUserId).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.episodeList = res.response;
          this.totalRecords = this.episodeList.length;
        } else {
          this.episodeList = [];
          this.totalRecords = 0;
        }
        this.isLoading = false;
      },
      (err: any) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
      this.getAllEpisodes();
    } else {
      this.getAllTvProductionTrackersUserId();
    }
  }

  openTitleModal(episode: any) {
    this.selectedEpisode = episode;
    this.titleForm.patchValue({
      ...episode,
      suggestedTitles: '',
      commonNotes: ''
    });
    this.formSubmit = false;
    this.selectedUserIdToAssign = "";
  }

  closeModal() {
    document.getElementById("closeTitleModalBtn")?.click();
    this.selectedEpisode = null;
    this.titleForm.reset();
    this.selectedUserIdToAssign = "";
  }

  saveDetails(complete: boolean) {
    if (this.titleForm.invalid) {
      this.formSubmit = true;
      this.toastr.error("Please fill required fields");
      return;
    }

    let suggestedTitlesArr = this.selectedEpisode.suggestedTitles || [];
    if (this.titleForm.get('suggestedTitles').value) {
      suggestedTitlesArr.push({
        titleName: this.titleForm.get('suggestedTitles').value
      });
    }

    let commonNotesArr = this.selectedEpisode.commonNotes || [];
    if (this.titleForm.get('commonNotes').value) {
      commonNotesArr.push({
        userId: Number(sessionStorage.getItem('userId')) || 0,
        userName: sessionStorage.getItem('userName') || '',
        commonNotes: this.titleForm.get('commonNotes').value,
        date: new Date().getTime()
      });
    }

    let nextStage = this.selectedEpisode.currentStage;
    if (complete && this.selectedUserIdToAssign) {
      nextStage = "QUALITY_CHECK";
    }

    let finalTitleEndDate = this.titleForm.get('titleCreationEndDate')?.value ? new Date(this.titleForm.get('titleCreationEndDate').value).getTime() : 0;
    let finalNoOfDays = this.titleForm.get('noOfDaysToTitle')?.value || 0;
    let finalNoOfHours = this.titleForm.get('noOfHoursToTitle')?.value || 0;
    let finalTitleStartDate = this.titleForm.get('titleCreationStartDate')?.value ? new Date(this.titleForm.get('titleCreationStartDate').value).getTime() : this.selectedEpisode.titleCreationStartDate;

    if (complete) {
      finalTitleEndDate = new Date().getTime();
      if (finalTitleStartDate) {
        const diffMs = finalTitleEndDate - finalTitleStartDate;
        finalNoOfDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
        finalNoOfHours = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60)));
      }
    }

    const payload: any = {
      ...this.selectedEpisode,
      commonNotes: commonNotesArr,
      titleCreationUser: this.titleForm.get('titleCreationUser').value,
      assignToTitleTeamOnDate: this.titleForm.get('assignToTitleTeamOnDate').value ? new Date(this.titleForm.get('assignToTitleTeamOnDate').value).getTime() : (this.selectedEpisode.assignToTitleTeamOnDate || 0),
      titleCreationStartDate: finalTitleStartDate || 0,
      titleCreationEndDate: finalTitleEndDate,
      noOfDaysToTitle: finalNoOfDays,
      noOfHoursToTitle: finalNoOfHours,
      suggestedTitles: suggestedTitlesArr,
      approvedTitle: this.titleForm.get('approvedTitle').value,
      episodeStatus: complete ? 'TITLE_COMPLETED' : this.selectedEpisode.episodeStatus,
      currentStage: nextStage,
      qualityCheckUser: (complete && this.selectedUserIdToAssign) ? this.selectedUserIdToAssign : this.selectedEpisode.qualityCheckUser,
      assignedUserId: (complete && this.selectedUserIdToAssign) ? Number(this.userList.find((item: any) => item.userName === this.selectedUserIdToAssign)?.userId || 0) : (this.selectedEpisode.assignedUserId || 0),
      assignToQualityCheckTeamOnDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.assignToQualityCheckTeamOnDate,
      qualityCheckStartDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() : this.selectedEpisode.qualityCheckStartDate,
      qualityDueDate: (complete && this.selectedUserIdToAssign) ? new Date().getTime() + (2 * 24 * 60 * 60 * 1000) : this.selectedEpisode.qualityDueDate,
      cid: this.cid
    };
    delete payload.episodeNotes;
    delete payload.editorNotes;
    delete payload.titleNotes;
    delete payload.graphicsNotes;
    delete payload.seoNotes;
    delete payload.qualityCheckNotes;
    delete payload.publishingNotes;

    this.tvProductionTrackerService.updateEpisodeWorkflow(payload).subscribe(
      (res: any) => {
        this.toastr.success(res.message || 'Workflow updated successfully');
        if (this.userType.toLowerCase() === "admin" || this.userType.toLowerCase() === "bo" || this.userType.toLowerCase() === "boadmin") {
          this.getAllEpisodes();
        } else {
          this.getAllTvProductionTrackersUserId();
        }
        if (complete) {
          this.closeModal();
        } else {
          this.selectedEpisode.suggestedTitles = suggestedTitlesArr;
          this.selectedEpisode.commonNotes = commonNotesArr;
          this.selectedEpisode.approvedTitle = payload.approvedTitle;
          this.titleForm.patchValue({
            suggestedTitles: '',
            commonNotes: ''
          });
        }
      },
      (err: any) => {
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error updating workflow');
      }
    );
  }

  isMyNote(note: any): boolean {
    if (!note || note.userId === undefined || note.userId === null) return false;
    return Number(note.userId) === Number(this.loggedInUserId);
  }

  sendChat() {
    const noteText = this.titleForm.get('commonNotes')?.value;
    if (!noteText) {
      return;
    }

    const payload = {
      userId: Number(sessionStorage.getItem('userId')) || 0,
      userName: sessionStorage.getItem('userName') || '',
      commonNotes: noteText,
      date: new Date().getTime()
    };

    this.tvProductionTrackerService.updateCommonNotes(this.selectedEpisode.tvProductionTrackerId, payload).subscribe(
      (res: any) => {
        let commonNotesArr = this.selectedEpisode.commonNotes || [];
        commonNotesArr.push(payload);
        this.selectedEpisode.commonNotes = commonNotesArr;
        this.titleForm.patchValue({ commonNotes: '' });
      },
      (err: any) => {
        this.toastr.error('Error sending chat');
      }
    );
  }
}
